// extracted by mini-css-extract-plugin
export default {"special_title":"SpecialTitle_special_title__TaF3M","special_title_text":"SpecialTitle_special_title_text__646QQ"};